import React from 'react';
import { Route, Switch } from 'react-router-dom'; 
import ForgotPasswordPage from '../pages/AuthPages/ForgotPasswordPage';
import LoginPage from '../pages/AuthPages/LoginPage';
import ResetPasswordPage from '../pages/AuthPages/ResetPasswordPage';

const AuthRoutes = () => {
  return (
    <Switch>
      <Route exact path='/' component={LoginPage} />
      <Route exact path='/auth' component={LoginPage} />
      <Route exact path="/fp" component={ForgotPasswordPage} />
      <Route path="/fp/rp/:data" component={ResetPasswordPage} />
    </Switch>
  );
};

export default AuthRoutes